import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import useTownController from '../../../../hooks/useTownController';

export default function BlackjackLeaderboard({
  isOpen,
  close,
}: {
  isOpen: boolean;
  close: () => void;
}) {
  const townController = useTownController();

  const [players, setPlayers] = useState(
    townController.players
      .sort((player1, player2) => player1.gamePoints - player2.gamePoints)
      .slice(0, 10),
  );

  useEffect(() => {
    setPlayers(
      townController.players
        .sort((player1, player2) => player1.gamePoints - player2.gamePoints)
        .slice(0, 10),
    );
  }, [townController, townController.players]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        close();
      }}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Leaderboard</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {players.map(eachPlayer => (
            <>
              <Text>
                Username: {eachPlayer.userName} Points: {eachPlayer.gamePoints.toString()}
              </Text>
            </>
          ))}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
